module.exports = __webpack_public_path__ + "static/media/post2.4298fc3f.jpg";